import React from "react";

function HonorsAndAwards() {
    return (
        <section className="honors-and-awards">
            <h1 className="heading">HONORS AND AWARDS</h1>

            <ul className="honor-or-award-points">
                <li>Editor's Choice Article, Machines (MDPI) - for "A Review on In-Situ Monitoring in Wire Arc Additive Manufacturing: Technologies, Applications, Challenges, and Needs"</li>
                <li>First Place, American Welding Society (AWS) Poster Competition (Undergraduate, B.S. Engineering) - 1st out of 25 student entries, $750 award</li>
            </ul>
        </section>
    );
}

export default HonorsAndAwards;
